function isToggleActive(toggle) {
  const toggles = getToggles();
  return toggles[toggle] === true;
}

function getToggles() {
  const moduleContainer = document.querySelector(".combo_combolist-container");
  const rawToggles =
    (moduleContainer && moduleContainer.getAttribute("data-toggles")) || "{}";
  try {
    return JSON.parse(rawToggles);
  } catch (err) {
    return {};
  }
}

export default isToggleActive;
